import { Set } from "immutable";
import { createSelector } from "reselect";

import {
  getAllSections,
  SectionId,
  Sections,
  sectionSelectors
} from "seneca-common/features/course/state";
import { getSection } from "seneca-common/features/course/state/selectors/state/sections";
import {
  getSectionStats,
  SectionStats
} from "seneca-common/features/stats/state";
import { getModuleIdsIncorrectLast } from "seneca-common/features/stats/state/selectors/state/sectionStats/stats";

export function getModuleIdsIncorrect(
  sectionStats: SectionStats,
  sections: Sections,
  sectionId: string
) {
  const section = getSection(sections, sectionId);
  const actualModuleIds = sectionSelectors.getModuleIds(section!);
  const incorrectModuleIds = getModuleIdsIncorrectLast(sectionStats, sectionId);
  const hasSequentialContent =
    sectionSelectors.doesSectionHaveSequentialContent(section!);

  if (hasSequentialContent) {
    return Set<string>();
  }

  const wrongAnswerModuleIds = Set(actualModuleIds).intersect(
    Set(incorrectModuleIds!)
  );

  return wrongAnswerModuleIds;
}

export function getAccurateNumberOfModuleIdsIncorrect(
  sectionStats: SectionStats,
  sections: Sections,
  sectionId: string
) {
  return getModuleIdsIncorrect(sectionStats, sections, sectionId).size;
}

export function makeGetAccurateNumberOfModuleIdsIncorrect(
  sectionId: SectionId
) {
  return createSelector(
    getAllSections,
    getSectionStats,
    (sections, sectionStats) => {
      return getAccurateNumberOfModuleIdsIncorrect(
        sectionStats as any,
        sections,
        sectionId
      );
    }
  );
}
